import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import { RandomCoupon } from './ScratchCoupon';

interface Props {
  coupon: RandomCoupon;
  onClose: () => void;
}

function CompleteModal({ coupon, onClose }: Props) {
  return (
    <BottomModal onClose={onClose}>
      <Header>
        <CloseButton onClick={onClose}>
          <img src="/assets/images/close/close-black24.svg" alt="" />
        </CloseButton>
      </Header>
      <Inner>
        <Title>
          축하드립니다!
          <TitleDesc>{coupon.name} 당첨!</TitleDesc>
        </Title>
        <Coupon>
          <CouponImg
            src="/assets/images/promotion/lucky/coupon.png"
            alt="coupon"
            draggable={false}
          />
          <CouponInner>
            <CouponTitle>
              {coupon.name}
              <CouponSub>{coupon.description2}</CouponSub>
            </CouponTitle>
            <CouponDate>사용기한 {coupon.expireText}까지</CouponDate>
          </CouponInner>
        </Coupon>
        <Desc>
          <span>・쿠폰 유효기간은 발급일로부터 7일입니다.</span>
          <span>
            ・당첨 후 바로 지급되며 [마이페이지 - 쿠폰함]에서 확인해 주세요.
          </span>
        </Desc>
      </Inner>

      <Bottom>
        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </Bottom>
    </BottomModal>
  );
}

export default CompleteModal;

const Header = styled.div`
  display: flex;
  width: 360px;
  padding: 24px 20px 0 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const CloseButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #f2f2f2;

  & > img {
    width: 20px;
    height: 20px;
  }
`;

const Inner = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  color: #138c2a;
  text-align: center;
  font-family: Paperlogy;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
`;

const TitleDesc = styled.div`
  color: #222;
  text-align: center;
  font-family: Paperlogy;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */
`;

const Coupon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  aspect-ratio: 312 / 134;
`;

const CouponImg = styled.img`
  width: 100%;
  height: 100%;

  position: absolute;
  inset: 0;
`;

const CouponInner = styled.div`
  z-index: 10;
  position: absolute;
  left: 32px;
  top: 27.5px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const CouponTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #000;
  font-family: 'Wanted Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: 130%; /* 26px */
`;

const CouponSub = styled.div`
  color: #000;
  font-family: 'Wanted Sans';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 19.5px */
`;

const CouponDate = styled.div`
  color: #565b56;
  text-align: center;
  font-family: 'Wanted Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const Desc = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;

  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const Bottom = styled.div`
  display: flex;
  padding: 24px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const ConfirmButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #222;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;
